import { NgModule } from '@angular/core';
import { CommonPackageModule } from 'src/app/modules/common-package.module';
import { CommonFeatureModule } from '../../common/common.module';
import { AcdDefineComponent } from '../components/acd-define/acd-define.component';
import { AcdPmBuildComponent } from '../components/acd-build/acd-pm-build/acd-pm-build.component';
import { AcdRequestViewComponent } from '../components/acd-request-view/acd-request-view.component';
import { AcdSearchComponent } from '../components/acd-search/acd-search.component';
import { AcdStepsComponent } from '../components/acd-steps/acd-steps.component';
import { AcdViewComponent } from '../components/acd-view/acd-view.component';
import { AcdMwoBuildComponent } from '../components/acd-build/acd-mwo-build/acd-mwo-build.component';
import { AcdEplBuildComponent } from '../components/acd-build/acd-epl-build/acd-epl-build.component';
import { AcdJobPlanBuildComponent } from '../components/acd-build/acd-jp-build/acd-jp-build.component';
import { AcdSummaryComponent } from '../components/acd-summary/acd-summary.component';
import { ObseluteItemsPopupComponent } from '../components/obselute-items-popup/obselute-items-popup.component';
import { AcdCreateComponent } from '../components/acd-create/acd-create.component';
import { AcdFormComponent1 } from '../components/acd-form/acd-form.component';
import { DateTransformPipe } from '../../../pipes/date-transform.pipe';
import { DateTransformToAWSTPipe } from '../../../pipes/date-transform-awst.pipe';

@NgModule({
  declarations: [AcdRequestViewComponent,
    AcdViewComponent,
    AcdStepsComponent,
    AcdDefineComponent,
    AcdSearchComponent,
    AcdMwoBuildComponent,
    AcdPmBuildComponent,
    AcdEplBuildComponent,
    AcdJobPlanBuildComponent,
    AcdSummaryComponent,
    ObseluteItemsPopupComponent,
    AcdCreateComponent,
    AcdFormComponent1,
    DateTransformPipe,
    DateTransformToAWSTPipe
  ],
  imports: [
    CommonPackageModule,
    CommonFeatureModule
  ]
})
export class AcdModule { }
